// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f1f19334","453":"f50b114d","667":"9b834733"}[chunkId] + ".chunk.js";
};